module.exports = __webpack_public_path__ + "media/images/premium/premium-card-logo-8a4d587d5578a15b4dab1c66d325f069.svg";